import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Divider, Button } from '@mui/material';
import EnvironmentSwitcher from '../../components/EnvironmentSwitcher';
import { isNonProdEnvironment } from '../../constants/api.constants';

// Import test components from new structure
import TestPing from './ping/TestPing';
import TestFiles from './file/TestFiles';
import TestDeals from './deal/TestDeals';
import TestProfile from './profile/TestProfile';
// TestTokenRefresh deleted 2026-04-20 with the Cognito auth removal.
// Clerk handles token refresh automatically via window.Clerk.session.
import TestOrganizations from './organization/TestOrganizations';
import TestMembers from './organization/TestMembers';
import TestInvites from './organization/TestInvites';
import TestRoles from './organization/TestRoles';
import TestMeetingBot from './meeting-bot/TestMeetingBot';
import TestIntegrations from './integrations/TestIntegrations';

/**
 * API Test Page component with tabs for testing different API endpoints
 */
export const ApiTestPage: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [showEnvironmentSwitcher, setShowEnvironmentSwitcher] = useState(false);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Equal-IQ API Testing
        </Typography>

        {isNonProdEnvironment() && (
          <Button
            variant="outlined"
            size="small"
            onClick={() => setShowEnvironmentSwitcher(true)}
          >
            Environment
          </Button>
        )}
      </Box>

      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{
          mb: 3,
          '& .MuiTab-root': {
            color: 'white',
            '&.Mui-selected': {
              color: 'white'
            }
          }
        }}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
      >
        <Tab label="Ping" />
        <Tab label="Files" />
        <Tab label="Deals" />
        <Tab label="Profile" />
        <Tab label="Auth" />
        <Tab label="Organizations" />
        <Tab label="Members" />
        <Tab label="Invites" />
        <Tab label="Roles" />
        <Tab label="Meeting Bot" />
        <Tab label="Email Integration" />
      </Tabs>

      <Divider sx={{ mb: 3 }} />

      {activeTab === 0 && <TestPing />}
      {activeTab === 1 && <TestFiles />}
      {activeTab === 2 && <TestDeals />}
      {activeTab === 3 && <TestProfile />}
      {activeTab === 4 && <div className="p-4 text-sm text-muted-foreground">Token refresh test removed — Clerk auto-refreshes via window.Clerk.session.</div>}
      {activeTab === 5 && <TestOrganizations />}
      {activeTab === 6 && <TestMembers />}
      {activeTab === 7 && <TestInvites />}
      {activeTab === 8 && <TestRoles />}
      {activeTab === 9 && <TestMeetingBot />}
      {activeTab === 10 && <TestIntegrations />}

      <EnvironmentSwitcher 
        open={showEnvironmentSwitcher} 
        onClose={() => setShowEnvironmentSwitcher(false)} 
      />
    </Box>
  );
};

export default ApiTestPage;